"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var GwsGameProviderCfgCtl = /** @class */ (function (_super) {
    __extends(GwsGameProviderCfgCtl, _super);
    function GwsGameProviderCfgCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this._errDialog = errDialog;
        return _this;
    }
    GwsGameProviderCfgCtl.prototype.ResetData = function () {
        this.DATA = {
            frontend_api_url: "",
            plugin_api_url: "",
            plugin_api_pwd_hash: "",
            game_demo_template_url_desktop: "",
            game_money_template_url_desktop: "",
            //game_bonus_template_url_desktop: "",
            game_demo_template_url_mobile: "",
            game_money_template_url_mobile: "",
            //game_bonus_template_url_mobile: "",
            cdn_baseurl: "",
            logo_width: 0,
            logo_height: 0,
            logo_width_1: 0,
            logo_height_1: 0,
            template_url_test_data: "",
            //streamer_operator_id: "0",
            money_operator_id: "0",
        };
    };
    GwsGameProviderCfgCtl.prototype.LoadData = function (key, onDone) {
        var _this = this;
        webAApi_1.DetailsGameProviderGwsConfigGet.exec({ gws_gameprovider_id: key }, function (resp) {
            _this.DATA.frontend_api_url = resp.frontend_api_url;
            _this.DATA.plugin_api_url = resp.plugin_api_url;
            _this.DATA.plugin_api_pwd_hash = resp.plugin_api_pwd_hash;
            _this.DATA.cdn_baseurl = resp.cdn_baseurl;
            _this.DATA.game_money_template_url_desktop = resp.game_money_template_url_desktop;
            _this.DATA.game_demo_template_url_desktop = resp.game_demo_template_url_desktop;
            //this.DATA.game_bonus_template_url_desktop = resp.game_bonus_template_url_desktop;
            _this.DATA.game_money_template_url_mobile = resp.game_money_template_url_mobile;
            _this.DATA.game_demo_template_url_mobile = resp.game_demo_template_url_mobile;
            //this.DATA.game_bonus_template_url_mobile = resp.game_bonus_template_url_mobile;
            _this.DATA.logo_width = resp.logo_width;
            _this.DATA.logo_height = resp.logo_height;
            _this.DATA.logo_width_1 = resp.logo_width_1;
            _this.DATA.logo_height_1 = resp.logo_height_1;
            //this.DATA.streamer_operator_id = resp.streamer_operator_id;
            _this.DATA.money_operator_id = resp.money_operator_id;
            _this.DATA.template_url_test_data = resp.template_url_test_data;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    GwsGameProviderCfgCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoEditGameProviderGwsConfig.exec({
            data: {
                gws_gameprovider_id: data.gws_gameprovider_id,
                frontend_api_url: data.frontend_api_url,
                plugin_api_url: data.plugin_api_url,
                plugin_api_pwd_hash: data.plugin_api_pwd_hash,
                cdn_baseurl: data.cdn_baseurl,
                logo_width: data.logo_width,
                logo_height: data.logo_height,
                logo_width_1: data.logo_width_1,
                logo_height_1: data.logo_height_1,
                game_demo_template_url_desktop: data.game_demo_template_url_desktop,
                game_money_template_url_desktop: data.game_money_template_url_desktop,
                //game_streamer_template_url_desktop: data.game_bonus_template_url_desktop,
                game_demo_template_url_mobile: data.game_demo_template_url_mobile,
                game_money_template_url_mobile: data.game_money_template_url_mobile,
                //game_bonus_template_url_mobile: data.game_bonus_template_url_mobile,
                //streamer_operator_id: data.streamer_operator_id,
                money_operator_id: data.money_operator_id,
            }
        }, function (resp) {
            _this.DATA.frontend_api_url = data.frontend_api_url;
            _this.DATA.plugin_api_url = data.plugin_api_url;
            _this.DATA.plugin_api_pwd_hash = data.plugin_api_pwd_hash;
            _this.DATA.cdn_baseurl = data.cdn_baseurl;
            _this.DATA.game_money_template_url_desktop = data.game_money_template_url_desktop;
            _this.DATA.game_demo_template_url_desktop = data.game_demo_template_url_desktop;
            //this.DATA.game_bonus_template_url_desktop = data.game_bonus_template_url_desktop;
            _this.DATA.game_money_template_url_mobile = data.game_money_template_url_mobile;
            _this.DATA.game_demo_template_url_mobile = data.game_demo_template_url_mobile;
            //this.DATA.game_bonus_template_url_mobile = data.game_bonus_template_url_mobile;
            _this.DATA.logo_width = data.logo_width;
            _this.DATA.logo_height = data.logo_height;
            _this.DATA.logo_width_1 = data.logo_width_1;
            _this.DATA.logo_height_1 = data.logo_height_1;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return GwsGameProviderCfgCtl;
}(BaseController_1.BaseController));
exports.GwsGameProviderCfgCtl = GwsGameProviderCfgCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gws_gameproviders_list/ctl/GwsGameProviderCfgCtl.ts
// module id = 940
// module chunks = 0